/**
 * util 工具类
 * 源于原util 改用ES6语法并适当优化
 * @author tankunpeng(tankunpeng@fang.com)
 * @update
 */

(function (w, f) {
    if (typeof define === 'function') {
        define('util',['jquery'], function (require) {
            const $ = require('jquery');
            return f($);
        });
    } else if (typeof exports === 'object') {
        module.exports = f(w);
    } else {
        if (!w.jQuery) {
            console.error('jQuery undefined');
            return;
        }
        w.util = f(w.jQuery);
    }
})(window, function ($) {
    // 引入依赖
    class Util {
        /**
         * 获取地址栏参数
         * @param key 无参数返回json对象
         * @returns {*}
         */
        static getQuery(key) {
            const queryStr = location.search.replace('?', '');
            let value;
            const json = {};

            if (queryStr) {
                const arr = queryStr.split('&');
                for (let i = 0, len = arr.length; i < len; i++) {
                    const arr2 = arr[i].split('=');
                    json[arr2[0]] = arr2[1];
                    if (arr2[0] === key) {
                        value = arr2[1];
                    }
                }
            }
            return key && typeof key === 'string' ? decodeURIComponent(value) : json;
        }

        /**
         * 获取地址栏参数
         * @param json json对象
         * @returns {*}
         */
        static setQuery(json) {
            const arr = [];
            for (const name in json) {
                if (json.hasOwnProperty(name)) {
                    const value = json[name];
                    let str = '';
                    if (typeof value === 'object') {
                        str = `${name}=${JSON.stringify(value)}`;
                    } else {
                        str = `${name}=${value}`;
                    }
                    arr.push(str);
                }
            }
            return arr.join('&');
        }

        /**
         * 页面滚动函数
         * @param obj
         */
        static topPosition(obj) {
            const $obj = $(obj);
            const p = $('#replyPostPosition');
            if ($obj === p) {
                $('.comBoxMain').hide();
            }
            if ($('#nav').is(':visible')) $('#nav').hide();
            const length = $obj.offset().top - 51;
            if (length) {
                $('body').animate({ scrollTop: length });
            }
            $('header').css({ position: 'fixed', width: '100%', top: '0', display: 'block' });
        }


        /**
         * 获取cookie
         * @param key
         * @returns {*}
         */
        static getCookie(key) {
            const reg = new RegExp('(^| )' + key + '=([^;]*)(;|$)');
            const arr = document.cookie.match(reg);
            if (arr) {
                let str;
                try {
                    str = decodeURIComponent(arr[2]);
                } catch (e) {
                    str = unescape(arr[2]);
                }
                return str;
            }
            return '';
        }

        /**
         * 设置cookie
         * @param key
         * @param value
         * @param iDay
         * @param domain
         */
        static setCookie(key, value, iDay, domain) {
            let domainStr = '';
            if (domain) {
                domainStr = `domain=${domain};`;
            }
            if (iDay) {
                const oDate = new Date();
                oDate.setDate(oDate.getDate() + Number(iDay));
                document.cookie = `${key}=${encodeURIComponent(value)};path=/;${domain ? domainStr : ''}expires=${oDate.toGMTString()}`;
            } else {
                document.cookie = `${key}=${encodeURIComponent(value)};${domain ? domainStr : ''}path=/`;
            }
        }

        /**
         * 删除cookie
         * @param key
         */
        static delCookie(key) {
            Util.setCookie(key, 1, -1);
        };


        /*
         * 获取global_cookie
         * @return uid
         */
        static getUID() {
            let uid = Util.getCookie('global_cookie');
            if (uid) {
                return uid;
            }
            uid = Util.getGUID();
            Util.setCookie('global_cookie', uid, 3, 'fang.com');
            return uid;
        }

        /*
         * 生成global_cookie
         * @return global_cookie
         */
        static getGUID() {
            let i = 0;
            let result = '';
            const pattern = '0123456789abcdefghijklmnopqrstuvwxyz';
            for (i = 0; i < 25; i++) {
                result += pattern.charAt(Math.round(Math.random() * 36));
            }
            const time = new Date().getTime();
            const str = '00000000' + time.toString(16).toLocaleLowerCase();
            const len = str.length;
            result += str.substring(len - 10);
            return result;
        }

        /**
         * @param {int} numbers 数字
         * @param {int} places 小数位
         * @param {string} symbols 货币符号
         * @param {string} thousand 千分位符号
         * @param {string} decimal 小数位符号
         * @param {string} math Math 方法，round|ceill|floor
         */
        static formatMoney(numbersP, placesP, symbolsP, thousandP, decimalP, mathP) {
            let numbers = numbersP || 0;
            let places = placesP;
            places = !isNaN(places = Math.abs(places)) ? places : 2;
            const symbols = symbolsP !== undefined ? symbolsP : '';
            const thousand = thousandP || ',';
            const decimal = decimalP || '.';
            const math = /round|ceil|floor/.test(mathP) ? mathP : 'ceil';

            const negative = numbers < 0 ? '-' : '';
            const i = String(parseInt(numbers = Math[math](Math.abs(Number(numbers) || 0)).toFixed(places), 10));
            const k = i.length;
            const j = k > 3 ? k % 3 : 0;
            return symbols + negative + (j ? i.substr(0, j) + thousand : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousand) + (places ? decimal + Math.abs(numbers - i).toFixed(places).slice(2) : '');
        }

        /**
         * [throttle 函数节流]
         * @param  {Function} fn      [要执行的函数]
         * @param  {[type]}   delay   [延迟多久执行]
         * @param  {[type]}   atleast [至少多久执行一次]
         */
        static throttle(fn, delay, atleast) {
            let timer = null;
            let previous = null;
            return function () {
                const now = Number(new Date());
                if (!previous) previous = now;
                if (atleast && now - previous > atleast) {
                    fn();
                    // 重置上一次开始时间为本次结束时间
                    previous = now;
                    clearTimeout(timer);
                } else {
                    clearTimeout(timer);
                    timer = setTimeout(function () {
                        fn();
                        previous = null;
                    }, delay);
                }
            };
        }
        // 格式化date 时间类型
        static toDou(num) {
            return num < 10 ? '0' + num : String(num);
        }
        // 获取现在时间，格式化过的
        static fotmatdate(){
            const now = new Date();
            const nowStr = this.toDou(now.getFullYear()) + '-' + this.toDou(now.getMonth() + 1) + '-' + this.toDou(now.getDate()) + ' ' + this.toDou(now.getHours()) + ':' + this.toDou(now.getMinutes()) + ':' + this.toDou(now.getSeconds());
            return nowStr;
        }
        static fotmatdatetoday(date, noyear){
            const now = new Date(date);
            let nowStr;
            if(noyear){
                nowStr = this.toDou(now.getMonth() + 1) + '-' + this.toDou(now.getDate());
            }
            else{
                nowStr = this.toDou(now.getFullYear()) + '-' + this.toDou(now.getMonth() + 1) + '-' + this.toDou(now.getDate());
            }
            return nowStr;
        }
    }

    // 暴露对应接口
    return Util;
});

/**
 * @file 房源推荐click统计 及 网店房源点击量
 * @author tankunpeng(tankunpeng@fang.com)
 * @update
 * Date: 2017/4/28
 */
define('detail/houseAdHitsImage',['jquery','util'], function (require) {
    const [$, util] = require(['jquery', 'util']);
    const vars = fang.data;

    const imagenServer = 'http://click5n.soufun.com/';
    const imagesServer = 'http://click5.soufun.com/';
    class HouseAdHitsImage {
        /**
         * 创建img统计标签
         * @param agentid
         * @param houseid
         * @param city
         * @param isnorth
         */
        create(agentid, houseid, city, isnorth) {
            const c = util.getQuery('c');
            if (c !== 'undefined') {
                const gd = c.split(',');
                if (gd[0] !== 'undefined') {
                    if (gd[0] === '1') {
                        const data = 'houseid=' + houseid;
                        const url = '/newsecond/include/Hits/Details.aspx';
                        $.get(url, data);
                    }
                    const hitsimage = 'agentad_' + agentid + '_' + houseid + '_' + city + '_acs_' + c + '.gif';
                    const img = document.createElement('img');
                    img.src = imagenServer + hitsimage;
                    img.style.display = 'none';
                    document.body.appendChild(img);
                }
            }
        }

        /**
         * 获取url地址
         * @param isnorth
         * @param type
         * @returns {string}
         */
        getUrl(isnorth, type) {
            let imageServer = imagenServer;
            if (/^[Yy0]$/.test(isnorth)) {
                if (type === '10' || type === '11') {
                    imageServer = 'http://clickshare.esf.soufun.com/share_';
                } else {
                    if (type === '10' || type === '11') {
                        imageServer = 'http://clickshare.esf.soufun.com/share_';
                    } else {
                        imageServer = imagenServer;
                    }
                }
            } else {
                imageServer = imagesServer;
            }
            return imageServer;
        }

        /**
         * 获取分享url地址
         * @param pageType
         * @param shortCity
         * @param isNorth
         * @param agentID
         * @param houseID
         * @returns {string}
         * @constructor
         */
        GetShareCountUrl(pageType, shortCity, isNorth, agentID, houseID) {
            let str = 'http://clickshares.esf.soufun.com/share_' + shortCity + '_esf_' + pageType + '_' + agentID + '_' + houseID + '.gif';
            if (/^[Yy0]$/.test(isNorth)) {
                str = 'http://clickshare.esf.soufun.com/share_' + shortCity + '_esf_' + pageType + '_' + agentID + '_' + houseID + '.gif';
            }
            return str;
        }
    }

    // 统计
    const localurl = window.location.href;
    if (/c=/.test(localurl)) {
        const imageHits = new HouseAdHitsImage();
        imageHits.create(vars.agentid, vars.houseid, vars.shortindb, /^[Yy0]$/.test(vars.isnorth) ? 'Y' : 'N');
    } else if (/mall=/.test(localurl)) {
        const mallInfo = util.getQuery('mall');
        let mallType = '';
        let mallNum = '';
        let mallSource = '';
        let url = '';
        const purpose = vars.purpose;

        const mallHouse = () => {
            try {
                if (mallInfo !== null) {
                    mallType = mallInfo.split(',')[0];
                    mallNum = mallInfo.split(',')[1];
                    if (mallInfo.split(',')[2]) {
                        mallSource = mallInfo.split(',')[2];
                    }
                    if (mallNum !== null && mallType !== null) {
                        if (/^[Yy0]$/.test(vars.isnorth)) {
                            url = 'http://clickstoren.esf.soufun.com/agent_';
                        } else {
                            url = 'http://clickstores.esf.soufun.com/agent_';
                        }
                        if (purpose === '住宅' || purpose === '别墅') {
                            url += vars.agentid + '_' + vars.houseid + '_' + vars.shortindb + '_cs_' + mallType + '_' + mallNum + (mallSource === '' ? '' : '_' + mallSource) + '.gif';
                        } else {
                            url += vars.agentid + '_' + vars.houseid + '_' + vars.shortindb + '_bus_' + mallType + '_' + mallNum + '.gif';
                        }
                        const img = document.createElement('img');
                        img.src = url;
                        img.style.display = 'none';
                        document.body.appendChild(img);
                    }
                }
            } catch (err) {
                console.error(err);
            }
        };
        mallHouse();
    } else if (/#spage=lianmengD,xq|#spage=lianmengND,xq|#spage=lianmengD|#spage=lianmengND/.test(localurl)) {
        const lianMengCountImg = document.createElement('img');
        const s = document.body;
        if (/#spage=lianmengD,xq|#spage=lianmengND,xq/.test(localurl)) {
            if (/^[Yy0]$/.test(vars.isnorth)) {
                lianMengCountImg.src = 'http://click6n.esf.fang.com/' + vars.shortindb + '_lm_pcxq_1_' + vars.projcode + '_' + vars.houseid + '_' + vars.agentid + '.gif';
            } else {
                lianMengCountImg.src = 'http://click6s.esf.fang.com/' + vars.shortindb + '_lm_pcxq_1_' + vars.projcode + '_' + vars.houseid + '_' + vars.agentid + '.gif';
            }
            s.appendChild(lianMengCountImg);
        } else if (/#spage=lianmengD|#spage=lianmengND/.test(localurl)) {
            if (/^[Yy0]$/.test(vars.isnorth)) {
                lianMengCountImg.src = 'http://click6n.esf.fang.com/' + vars.shortindb + '_lm_pc_1_' + vars.projcode + '_' + vars.houseid + '_' + vars.agentid + '.gif';
            }
            else {
                lianMengCountImg.src = 'http://click6s.esf.fang.com/' + vars.shortindb + '_lm_pc_1_' + vars.projcode + '_' + vars.houseid + '_' + vars.agentid + '.gif';
            }
            lianMengCountImg.style.display = 'none';
            s.appendChild(lianMengCountImg);
        }
    }

});
